import { Flex, Menu, Text, useMantineTheme } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { ArrowDown2, Global, TickCircle } from "iconsax-react";
import es from "../../locales/es/flag.svg";
import en from "../../locales/en/flag.svg";
import pt_br from "../../locales/pt_br/flag.svg";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

interface IProps {
  close: () => void;
}

const LANGUAGES = [
  { value: "pt-BR", label: "global.language.pt_br", flag: pt_br },
  { value: "en-US", label: "global.language.en_us", flag: en },
  { value: "es", label: "global.language.es", flag: es },
];

export default function MenuLanguage({ close }: IProps) {
  const theme = useMantineTheme();
  const { i18n, t } = useTranslation();
  const [value, setValue] = useState(i18n.language);
  const queryClient = useQueryClient();
  const [opened, { toggle }] = useDisclosure(false);

  useEffect(() => {
    if (value !== i18n.language) {
      i18n.changeLanguage(value);
      localStorage.setItem("i18nextLng", value);
      queryClient.invalidateQueries();
    }
  }, [value, i18n, queryClient]);

  const handleSelectProfile = (language: string) => {
    setValue(language);
    toggle();
    close();
  };

  return (
    <>
      <Menu.Item
        icon={<Global size={28} color={theme.colors.basic[5]} />}
        onClick={toggle}
      >
        <Flex w="100%" justify="space-between">
          <Text w={"fit-content"}>{t("global.language.modify_language")}</Text>
          <ArrowDown2
            size={24}
            color={theme.colors.basic[5]}
            style={{
              transform: opened ? "rotatex(180deg)" : "unset",
              transition: "0.5s",
            }}
          />
        </Flex>
      </Menu.Item>
      {opened
        ? LANGUAGES.map((language, index) => {
            const isRoleSelected = language.value === i18n.language;
            return (
              <Menu.Item
                key={`language${index}`}
                onClick={() => handleSelectProfile(language.value)}
                icon={
                  <Flex
                    h="28px"
                    w="28px"
                    align="center"
                    justify="center"
                    style={{ borderRadius: "8px" }}
                  >
                    <img
                      src={language.flag}
                      alt={t(language.label)}
                      width={22}
                      height={22}
                    />
                  </Flex>
                }
                bg={isRoleSelected ? theme.colors.primary[0] : "unset"}
                color={isRoleSelected ? "white" : "unset"}
                sx={(theme) => ({
                  "&:hover": {
                    backgroundColor: isRoleSelected
                      ? theme.colors.primary[1]
                      : theme.colors.primaryOpacity[4],
                    color: isRoleSelected ? "white" : theme.colors.basic[6],
                  },
                })}
              >
                <Flex w="100%" justify="space-between" align={"center"}>
                  {t(language.label)}
                  {isRoleSelected ? (
                    <TickCircle size="18" color="white" />
                  ) : null}
                </Flex>
              </Menu.Item>
            );
          })
        : null}
    </>
  );
}
